import { render } from "./VerificationQueue.vue?vue&type=template&id=792604e0"
import script from "./VerificationQueue.vue?vue&type=script&lang=js"
export * from "./VerificationQueue.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"VerificationQueue.vue"]])

export default __exports__